module.exports = __webpack_public_path__ + "img/dataReport.c54a1f9f.svg";